
// @mui material components
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import Drop from "../../assets/images/upload.png";
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Customer from "layouts/customer";
import Vendor from "layouts/vendor";
import Material from "layouts/material";
  import { Bars } from 'react-loader-spinner'
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import Autocomplete from '@mui/material/Autocomplete';
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import { useDropzone2 } from "react-dropzone";
import "layouts/style.css";
// Data

import { authDistributionChannel, authIncoterm, authIncoterm2, fileBPUpload, authPricingProcedure, authCustomerStatisticGroup, authDivision, authRegion, authSalesDistrict, authGoodsTAX, authCompanyCode, authSalesOfficeGroupMapping, authReconAccount, authPartnerFunction, authShippingCondition, authSalesGroup, authSalesOffice, authTermsofPayment, authAccountGroup, authSalesOrganization, authPostalCodeMaster, authGeoMapping, authRegionSalesDistrict, authIndustryCode, authAccountAssignmentGroup, authBPCreation, authBP, authGSTNIntegration, getGSTValidation } from '../../assets/globalAPI/GlobalApi';
function Bp() {
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({});
  const [file, setFile] = useState({});
  const [fileGallery, setFileGallery] = useState({});
  const { getRootProps: getRootfileProps, getInputProps: getInputfileProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFile) => {
      setFile(
        Object.assign(acceptedFile[0], {
          preview: URL.createObjectURL(acceptedFile[0]),
        }),
      );
    },
  });

  const { getRootProps: getRootGalleryProps, getInputProps: getInputGalleryProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFile) => {
      setFileGallery(
        Object.assign(acceptedFile[0], {
          preview: URL.createObjectURL(acceptedFile[0]),
        }),
      );
    },
  });


  const toastId = React.useRef(null);
  const [userAccess, setUserAccess] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userID, setUserID] = useState('');
  const [userName, setUserName] = useState('');
  const [category, setCategory] = useState({ value: "Masters", label: "Masters" });
  const [companyCode, setCompanyCode] = useState({});
  const [salesOrganization, setSalesOrganization] = useState({});
  const [panDocumentArray, setpanDocumentArray] = useState({});
  const [incoterm, setIncoterm] = useState({});
  const [incoterm2, setIncoterm2] = useState({});
  const [loaderspinner, setLoaderSpinner] = useState(false);
  const [addressexist, setaddressexist] = useState(true);
  const [mkCustomerExist, setMKCustomerExist] = useState(false);
  const [ipExist, setIPExist] = useState(true);
  const [mkCustomerValue, setMKCustomerValue] = useState('');
  const [SalesOrganizationValidation, setSalesOrganizationValidation] = useState(false);
  const [showTANNumber, setShowTANNumber] = useState(false);
  const [showPartnerFunctionBlock, setShowPartnerFunctionBlock] = useState(true);
  const [distributionChannel, setDistributionChannel] = useState({});
  const [selectDistributionChannel, setSelectDistributionChannel] = useState('');
  const [CreditControlOptions, setCreditControlOptions] = useState({});
  const [selectDivision, setSelectDivision] = useState('');
  const [selectRegion, setSelectRegion] = useState('');
  const [DistributionChannelvalidation, setDistributionChannelvalidation] = useState(false);
  const [panValidation, setPanValidation] = useState(false);
  const [panValidation2, setPanValidation2] = useState(false);
  const [division, setDivision] = useState({});
  const [goodstax, setGoodsTAX] = useState({});
  const [accountGroup, setAccountGroup] = useState({});
  const [selectedAccountGroup, setSelectedAccountGroup] = useState('');
  const [accountGroupValidation, setaccountGroupValidation] = useState(false);
  const [street, setStreet] = useState({});
  const [selectstreet, setSelectStreet] = useState('');
  const [city1, setCity1] = useState({});
  const [selectcity1, setSelectcity1] = useState('');
  const [city2, setCity2] = useState({});
  const [selectDistrict, setSelectDistrict] = useState('');
  const [accountAssignmentGroup, setAccountAssignmentGroup] = useState({});
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [selectedPANFiles, setSelectedPANFiles] = useState(undefined);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [postalCode, setPostalCode] = useState({});
  const [region, Setregion] = useState({});
  const [termsPayment, setTermsPayment] = useState({});
  const [salesDistrict, setSalesDistrict] = useState({});
  const [salesOffice, setSalesOffice] = useState({});
  const [pricingProcedure, setPricingProcedure] = useState({});
  const [customerStatisticGroup, setCustomerStatisticGroup] = useState({});
  const [salesGroup, setSalesGroup] = useState({});
  const [shippingCon, setShippingCon] = useState({});
  const [partnerFunction, setPartnerFunction] = useState({});
  const [reaconAccount, setReaconAccount] = useState({});
  const [name, setName] = useState("");
  const [ip, setIP] = useState("");
  const [ep, setEP] = useState("");
  const [tan, setTAN] = useState("");
  const [selectname1, setSelectName1] = useState(false);
  const [selectname3, setSelectName3] = useState(false);
  const [bpAccess, setBPAccess] = useState(false);
  const [customerAccess, setCustomerAccess] = useState(false);
  const [vendorAccess, setVendorAccess] = useState(false);
  const [partnerFunc, setPartnerFunc] = useState([]);
  const [selectMobile, setSelectMobile] = useState('');
  const [selectEmail, setSelectEmail] = useState('');
  const [selectPAN, setSelectPAN] = useState('');
  const [selectGSTN, setSelectGSTN] = useState('');
  const [selectIndustryCode, setSelectIndustryCode] = useState('');
  const [selectLedger, setSelectLedger] = useState('');
  const [selectSalesGroup, setSelectSalesGroup] = useState('');
  const [selectCustomerGroup, setSelectCustomerGroup] = useState('');
  const [selectShippingCondition, setSelectShippingCondition] = useState('');
  const [selectIndicator, setSelectIndicator] = useState('');
  const [selectIncoterms1, setSelectIncoterms1] = useState('');
  const [selectIncoterms2, setSelectIncoterms2] = useState('');
  const [selectPaymentKey, setSelectPaymentKey] = useState('');
  const [selectCreditControl, setSelectCreditControl] = useState('');
  const [selectAssignmentGroup, setSelectAssignmentGroup] = useState('');
  const [selectTAXClassification1, setSelectTAXClassification1] = useState('');
  const [selectTAXClassification2, setSelectTAXClassification2] = useState('');
  const [selectSalesOrganization, setSelectSalesOrganization] = useState('');
  const [validationStatus, setvalidationStatus] = useState('');
  const [industryCode, setIndustryCode] = useState({});
  const [loader, setLoader] = useState(false);

  const [formValues, setFormValues] = useState({
    client: {
      value: '',
      error: false
    },
    supplier: {
      value: ''
    },
    title: {
      value: '',
      error: false
    },
    postal_code: {
      value: ''
    },
    city: {
      value: ''
    },
    street: {
      value: '',
      error: false
    },
    region: {
      value: '',
      error: false
    },
    country: {
      value: 'IN',
      error: false
    },
    language_key: {
      value: 'ENG',
      error: false
    },
    telephone_number: {
      value: '',
      error: false
    },
    email: {
      value: '',
      error: false
    },
    pan: {
      value: '',
      error: false
    },
    account_group: {
      value: ''
    },
    gstn: {
      value: ''
    },
    purchase_organization: {
      value: '',
      error: false
    },
    currency: {
      value: 'INR',
      error: false
    },
    gr_based: {
      value: '',
      error: false
    },
    incoterms1: {
      value: '',
      error: false
    },
    incoterms2: {
      value: '',
      error: false
    },
    schema_group_supplier: {
      value: '',
      error: false
    },
    purchasing_group: {
      value: '',
      error: false
    },
    incoterms_location1: {
      value: 'X',
      error: false
    },
    reconciliation_account : {
      value: '',
      error: false
    },
    company_code: {
      value: '',
      error: false
    },
    sort_key: {
      value: '',
      error: false
    },
    payment_terms : {
      value: '',
      error: false
    },
    check_double_invoice: {
      value: '',
      error: false
    },
    previous_account_no: {
      value: '',
      error: false
    },
    wtax_country: {
      value: '',
      error: false
    }
  })
  useEffect(() => {
    if (localStorage.getItem('userid_details')) {
      let session = localStorage.getItem('userid_details');
      let userid_array = JSON.parse(session);
      let user_type = userid_array.user_type;
      let user_email = userid_array.email;
      let user_name = userid_array.name;
      let user_id = userid_array.userid;
      let userid = userid_array.id;
      setUserAccess(user_type);
      setUserEmail(user_email);
      setUserName(user_id);
      setUserID(userid);
    } else {
      // navigate('/');
    }
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    }

  }, []);
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  const gstn_files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }
  const handlePostalCode = (event) => {
    var postal_code = event.target.value;
    let length = postal_code.length;
    const regex = /^[0-9\b]+$/;
    if(length==6 && regex.test(postal_code))
    {
    formValues.postal_code.value = event.target.value;
    formValues.postal_code.error = false;
    
    
      setLoaderSpinner(true);
      const data = {
        "action": 'geo_mapping',
        "postal_code": postal_code
      };
      //console.log(data);
      authGeoMapping(JSON.stringify(data)).then(function (response) {
        var res = response.data;
       
        if (res.status == 'true' && res.code == '200') {
          setLoaderSpinner(false);
          setCity1(res.city);
          setCity2(res.district);
          setStreet(res.street);
          Setregion(res.region);
          
        } else {
          setLoaderSpinner(false);
        }
      }.bind(this)
      )
        .catch(function (error) {
          setLoader(false)
          console.log(error);
        });

    }else{
      formValues.postal_code.error = true;
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Postal Code should be numeric and 6 character long!", {
          className: "small-toast",
        });
      }
    }
    
  }
  const handleStreetOnChange = async (event) => {  
    formValues.street.error = false;
    setSelectStreet(event.value);
  }
  const handlePAN = async (event) => {
    formValues.pan.value = event.target.value;
    formValues.pan.error = false;
    var pan = event.target.value;
    var fourth_char = pan.charAt(3);
    if (fourth_char == 'C') {
      setPanValidation(true);
      formValues.adhar_pan_link.value = 0;
    } else if (fourth_char == 'P') {
      setPanValidation2(true);
    }
    else {
      setPanValidation2(false);
      setPanValidation(false);
    }
  }
  const handleChangeGSTN = (event) => {
    formValues.gstn.value = event.target.value;
  }
  const handleChangeEmail = async (event) => {
    var email_address = event.target.value;
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (email_address.match(validRegex)) {
      formValues.email.value = event.target.value;
      formValues.email.error = false;
    }else{
      formValues.email.error = true;
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Not a valid email address!", {
          className: "small-toast",
        });
      }
    }
  }
  const handleChangeIndicator = async (event) => {
    formValues.indicator.value = event.target.value;
    formValues.indicator.error = false;
  }
  const handleChangeMobile = async (event) => {
    const regex = /^[0-9\b]+$/;
    if (event.target.value === "" || regex.test(event.target.value)) {
    formValues.mobile.value = event.target.value;
    formValues.mobile.error = false;
    }else{
     
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Mobile number must be numeric!", {
          className: "small-toast",
        });
      }
    }
  }
  const handleChangeTelephone = async (event) => {
    const regex = /^[0-9\b]+$/;
    if (event.target.value === "" || regex.test(event.target.value)) {
    formValues.telephone_number.value = event.target.value;
    }else{
     
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Telephone number must be numeric!", {
          className: "small-toast",
        });
      }
    }
  }
  const handleNameChange3 = async (event) => {

    formValues.name3.value = event.target.value;
    formValues.name3.error = false;
  }
  function isNumeric(value) {
    return /^-?\d+(\.\d+)?$/.test(value);
  }
  const handleChangeBP = async (event) => {
    console.log(isNumeric(event.target.value));
    if(isNumeric(event.target.value)==true)
    {
      formValues.sold_to_party.value = event.target.value;
    }else{
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Sold To Party field should be numeric!");
      }
    }
  }
  const handleChangeIP = async (event) => {
    formValues.ip.value = event.target.value;
    setIP(event.target.value);
  }
  const handleChangeEP = async (event) => {
    formValues.ep.value = event.target.value;
    formValues.ep.error = false;
    setEP(event.target.value);
  }
  function validateString(str) {
    const regex = /^[A-Za-z]{4}[0-9]{5}[A-Za-z]$/;
    return regex.test(str);
  }
  const handleChangeTN = async (event) => {
    let tax_number = event.target.value;
    //formValues.tan.value = event.target.value;
    //setTAN(event.target.value);

    if(tax_number=='NA')
    {
      formValues.tan.value = event.target.value;
      setTAN(event.target.value);
    }else{
        let result = validateString(tax_number);
        if(result==true)
        {
          formValues.tan.value = event.target.value;
          setTAN(event.target.value);
        }else{
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.warning("TAX Number 5 field format not supported!");
          }
        }
    }
   
  }
  const handlePartnerFunction = async (options) => {
    
    formValues.partner_function.value = options;
    formValues.partner_function.error = false;
    setPartnerFunc(options);
  }
  const handleNameChange = async (event) => {

    formValues.name1.value = event.target.value;
    formValues.name3.value = event.target.value;
    formValues.search_term1.value = event.target.value;
    formValues.comment.value = event.target.value;
    formValues.name1.error = false;
    formValues.name3.error = false;
    document.getElementById("name_3").value = event.target.value;
    document.getElementById("search_term1").value = event.target.value;
    document.getElementById("comment").value = event.target.value;


  }
  // const handleChangeRegion = async (event) => {
  //   formValues.region.value = event.value;
  //   formValues.region.error = false;
  //   setSelectRegion(event.value);
  //   const data = {
  //     "action": 'get_region_sales_district',
  //     "region": event.value
  //   };
  //   //console.log(data);
  //   authRegionSalesDistrict(JSON.stringify(data)).then(function (response) {
  //     var res = response.data;
  //     //console.log(res);
  //     if (res.status == 'true' && res.code == '200') {
  //       setLoaderSpinner(false);
  //       setSalesDistrict(res.array);
  //     } else {
  //       setLoaderSpinner(false);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);
  //     });




  // }
  const handleChangeTAXClassification3 = async (event) => {
    formValues.tax_classification3.value = event.value;
    formValues.tax_classification3.error = false;
  }
  const handleChangeTAXClassification4 = async (event) => {
    formValues.tax_classification4.value = event.value;
    formValues.tax_classification4.error = false;
  }
  const handleChangeTAXClassification5 = async (event) => {
    formValues.tax_classification5.value = event.value;
    formValues.tax_classification5.error = false;
  }
  const handleChangeTAXClassification6 = async (event) => {
    formValues.tax_classification6.value = event.value;
    formValues.tax_classification6.error = false;
  }
  const handleChangeCustomerGroup = async (event) => {
    formValues.customer_group.value = event.value;
    if(event.value=='03')
    {
      //console.log(event.value);
      setTax6([{ value: "2", label: "2 -Non Taxable CGST" }]);
      setTax4([{ value: "2", label: "2 -Non Taxable CGST" }])
      setTax3([{ value: "2", label: "2 -Non Taxable CGST" }])
      setTax2([{ value: "2", label: "2 -Non Taxable CGST" }])
      setTax1([{ value: "2", label: "2 -Non Taxable CGST" }])
     
    }else{
      setTax6([{ value: "0", label: "0 -Taxable under GST" },
      { value: "1", label: "1 -CGST Exempted" },
      { value: "2", label: "2 -Non Taxable CGST" },
      { value: "3", label: "3 -Excisable with GST" },
      { value: "4", label: "4 -Sales Return No Tax" }]);
      setTax4([{ value: "0", label: "0 -Taxable under GST" },
      { value: "1", label: "1 -CGST Exempted" },
      { value: "2", label: "2 -Non Taxable CGST" },
      { value: "3", label: "3 -Excisable with GST" },
      { value: "4", label: "4 -Sales Return No Tax" }])
      setTax3([ { value: "0", label: "0 -Taxable under GST" },
      { value: "1", label: "1 -CGST Exempted" },
      { value: "2", label: "2 -Non Taxable CGST" },
      { value: "3", label: "3 -Excisable with GST" },
      { value: "4", label: "4 -Sales Return No Tax" }])
      setTax2([{ value: "0", label: "0 -Taxable under GST" },
      { value: "1", label: "1 -CGST Exempted" },
      { value: "2", label: "2 -Non Taxable CGST" },
      { value: "3", label: "3 -Excisable with GST" },
      { value: "4", label: "4 -Sales Return No Tax" }])
      setTax1([{ value: "0", label: "0 -Taxable under GST" },
      { value: "1", label: "1 -CGST Exempted" },
      { value: "2", label: "2 -Non Taxable CGST" },
      { value: "3", label: "3 -Excisable with GST" },
      { value: "4", label: "4 -Sales Return No Tax" }])
    }
  }
  const handleChangePricingProcedure = async (event) => {
    formValues.pricing_procedure.value = event.value;
  }
  const handleChangeSalesOffice = async (event) => {
    formValues.sales_office.value = event.value;
    let sales_office = event.value;
    const data = {
      "action": 'sales_office_group_mapping',
      "sales_office": sales_office
    };

    authSalesOfficeGroupMapping(JSON.stringify(data)).then(function (response) {
      var res = response.data;
      if (res.status == 'true' && res.code == '200') {
        setSalesGroup(res.array);
      } else {
        setSalesGroup(res.array);
      }
    }.bind(this)
    )
      .catch(function (error) {
        setLoader(false)
        console.log(error);

      });

  }
  const handleChangeSalesDistrict = async (event) => {
    formValues.sales_district.value = event.value;
  }
  const handleChangeFranchise = async (event) => {
    formValues.franchise_type.value = event.value;
  }
  const handleChangeMKCustomer = async (event) => {
    setMKCustomerValue(event.value);
  }
  const handleChangeAttribute1 = async (event) => {
    formValues.attribute1.value = event.value;
    formValues.attribute1.error = false;
  }
  const handleChangeAttribute2 = async (event) => {
    formValues.attribute2.value = event.value;
    formValues.attribute2.error = false;
  }
  const handleChangeIndustryCode1 = async (event) => {
    formValues.industry_code1.value = event.value;
    formValues.industry_code1.error = false;
    setSelectIndustryCode(event.value);
  }
  const handleChangePaymentKey = async (event) => {
    formValues.payment_key.value = event.value;
    formValues.payment_key.error = false;
    setSelectPaymentKey(event.value);
  }
 
 
  const handleChangeCreditControl = async (event) => {
    formValues.credit_control_area.value = event.value;
    formValues.credit_control_area.error = false;
    setSelectCreditControl(event.value);
  }
  const handleChangeTAXClassification1 = async (event) => {
    formValues.tax_classification1.value = event.value;
    formValues.tax_classification1.error = false;
    setSelectTAXClassification1(event.value);
  }
  const handleChangeGeneralLedger = async (event) => {
    formValues.general_ledger.value = event.value;
    formValues.general_ledger.error = false;
    setSelectLedger(event.value);
  }
  const handleChangeAssignment = async (event) => {
    formValues.account_assignment_group.value = event.value;
    formValues.account_assignment_group.error = false;
    setSelectAssignmentGroup(event.value);
  }
  const handleChangeShippingCondition = async (event) => {
    formValues.shipping_condition.value = event.value;
    formValues.shipping_condition.error = false;
    setSelectShippingCondition(event.value);
  }
  const handleChangeSalesGroup = async (event) => {
    formValues.sales_group.value = event.value;
    formValues.sales_group.error = false;
    setSelectSalesGroup(event.value);
  }
  const handleChangeStatisticGroup = async (event) => {
    formValues.customer_statistic_group.value = event.value;
    formValues.customer_statistic_group.error = false;
    //setSelectCustomerGroup(event.value);
  }
  const handleChangeTAXClassification2 = async (event) => {
    formValues.tax_classification2.value = event.value;
    formValues.tax_classification2.error = false;
    setSelectTAXClassification2(event.value);
  }
  const handleChangeADHARPANYES = async (event) => {

    if (event.target.checked == true) {
      formValues.adhar_pan_link.value = 1;
    } else {

    }

  }
  const handleChangeADHARPANNO = async (event) => {

    if (event.target.checked == true) {
      formValues.adhar_pan_link.value = 1;
    } else {

    }

  }
  const filterObjectByValue = (obj, predicate) =>{
  return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => predicate(value))
  );
}
  const handleChangeValue = async (event) => {
    if(event.value=='19')
    {
      setaddressexist(false);
      setMKCustomerExist(false);
      formValues.postal_code.value = 'NA';
      formValues.postal_code.error = false;
      formValues.city.value = 'NA';
      formValues.city.error = false;
      formValues.district.value = 'NA';
      formValues.district.error = false;
      formValues.street.value = 'NA';
      formValues.street.error = false;
      formValues.region.value = 'NA';
      formValues.ip.value = '';
      document.getElementById('country').value = '';
      
      formValues.region.error = false;
      
      formValues.sales_group.value = 'NA';
      formValues.sales_group.error = false;
      setIPExist(false);
    }else{
      if(event.value=='36')
      {
            document.getElementById('country').value = 'IN';
            formValues.country.value = 'IN';
            setaddressexist(true);
            //console.log(event.value);
            setIPExist(true);
            
            if(selectedAccountGroup=='Z011')
            {
            setMKCustomerExist(true);
            }else{
              setMKCustomerExist(false);
            }

      }else{
        document.getElementById('country').value = 'IN';
        formValues.country.value = 'IN';
        setaddressexist(true);
        //console.log(event.value);
        setIPExist(false);
        setMKCustomerExist(false);
      }
    }

    formValues.distribution_channel.value = event.value;
    formValues.distribution_channel.error = false;
    document.getElementById('industry_key').value = event.value;
    
    setSelectDistributionChannel(event.value);
    let account_group = selectedAccountGroup;
    let dc = event.value;
    const data = {
      "action": "status_gstn_validation",
      "account_group": account_group,
      "dc": dc
    };

    const recon_account_data = {
      "action": ' recon_account',
      "dc": dc
    };
    
    const account_assignment_group_data = {
      "action": 'account_assignment_group',
      "dc" : event.value
    };
    
    authAccountAssignmentGroup(JSON.stringify(account_assignment_group_data)).then(function (response) {
      var res = response.data;
      if (res.status == 'true' && res.code == '200') {
        setAccountAssignmentGroup(res.array);
      } else {
        setAccountAssignmentGroup(res.array);
      }
    }.bind(this)
    )
      .catch(function (error) {
        setLoader(false)
        console.log(error);

      });


    authReconAccount(JSON.stringify(recon_account_data)).then(function (response) {
      var res = response.data;
      if (res.status == 'true' && res.code == '200') {
        setReaconAccount(res.array);
        let recon_account_array = res.array;
        let recon_account_value = recon_account_array[0]['value'];
        formValues.general_ledger.value = recon_account_value;
      } else {
        setReaconAccount(res.array);
      }
    }.bind(this)
    )
      .catch(function (error) {
        setLoader(false)
        console.log(error);

      });
    getGSTValidation(JSON.stringify(data)).then(function (response) {
      var res = response.data;
      if (res.status == 'true' && res.code == '200') {
        setvalidationStatus(res.gstn_validation);
      } else {
        setvalidationStatus(res.gstn_validation);
      }
    }.bind(this)
    )
      .catch(function (error) {
        console.log(error);

      });
  }
  const handleChangePANReference = async (event) => {
    let pan_reference = event.target.value;
    let pan_reference_length = pan_reference.length;
    if(pan_reference_length==21)
    {
      formValues.pan_reference.value = event.target.value;  
    }else{
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("PAN reference should be exactly 21 character long!");
      }
    }
  }
  const handleChangeDivisionValue = async (event) => {
    //console.log(event.value);
    var credit_control_value = [];
    if(event.value=='00' || event.value=='40' || event.value=='43')
    {
      
        credit_control_value = [
                { value: '1000', label: '1000-HAD General Credit Control' }
              ];
        setCreditControlOptions(credit_control_value);

    }else if(event.value=='41' || event.value=='42'){
      credit_control_value = [
        { value: 'Z001', label: 'Z001-HAD-Credit-Additives/Accessories' }
      ];
        setCreditControlOptions(credit_control_value);

    }else{

    }
    formValues.division.value = event.value;
    formValues.division.error = false;
    setSelectDivision(event.value);
  }
  const handleChangeSO = async (event) => {
    formValues.sales_organization.value = event.value;
  }
  const handleOnChangeCC = async (event) => {
    formValues.company_code.value = event.value;
    var credit_control_value = [];
    var sales_org = [];
    if(event.value=='1000')
    {
      credit_control_value = [
        { value: '1000', label: '1000-HAD General Credit Control' },{ value: 'Z001', label: 'Z001-HAD-Credit-Additives/Accessories' }
      ];
      sales_org = [
        { value: '1000', label: '1000-HAD: Sale of FG' },{ value: '2000', label: '2000-HAD:Spares/Services' }
      ];
    }else if(event.value=='3000'){
      credit_control_value = [
        { value: '3000', label: '3000' },{ value: 'R001', label: 'R001' }
      ];

      sales_org = [
        { value: '3000', label: '3000-HAD:Ref Sale of FG' },{ value: '4000', label: '4000-HAD:Ref Spare/Services' }
      ];
      
    }else{

    }
    setSalesOrganization(sales_org);
    setCreditControlOptions(credit_control_value);
  }
  // const handleOnChange = async (event) => {
  //   console.log(event.value);
  //   formValues.customer_account_group.value = event.value;
  //   formValues.indicator.value = 'X';
  //   formValues.name4.value = 'X';
  //   formValues.customer_account_group.error = false;
  //   setSelectedAccountGroup(event.value);
  //   const data = {
  //     "action": 'distributionChannel'
  //   };
  //   const company_code_data = {
  //     "action": 'company_code'
  //   };
  //   const goods_tax_data = {
  //     "action": 'goods_tax'
  //   };
  //   const division_data = {
  //     "action": 'division'
  //   };
  //   const region_data = {
  //     "action": 'region'
  //   };
  //   const sales_district_data = {
  //     "action": 'sales_district'
  //   };
  //   const sales_office_data = {
  //     "action": 'sales_office'
  //   };
  //   const terms_of_payment_data = {
  //     "action": 'terms_of_payment'
  //   };
  //   const industry_code_data = {
  //     "action": 'industry_code'
  //   };
  //   const shipping_condition_data = {
  //     "action": 'shipping_condition'
  //   };
  //   const partner_function_data = {
  //     "action": 'partner_function'
  //   };

  //   const pricing_procedure_data = {
  //     "action": 'pricing_procedure'
  //   };

  //   const customer_statistics_group_data = {
  //     "action": 'customer_statistic_group'
  //   };

  //   const incoterm_data = {
  //     "action": 'incoterm'
  //   };

  //   authIncoterm(JSON.stringify(incoterm_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       formValues.incoterms1.value = res.value;
  //       formValues.incoterms2.value = res.value;
  //       setIncoterm(res.array);
  //       setIncoterm2(res.array);
  //     } else {
  //       setIncoterm(res.array);
  //       setIncoterm2(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authDistributionChannel(JSON.stringify(data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setDistributionChannel(res.array);
  //     } else {
  //       setDistributionChannel(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //     authPricingProcedure(JSON.stringify(pricing_procedure_data)).then(function (response) {
  //       var res = response.data;
        
  //       if (res.status == 'true' && res.code == '200') {
  //         formValues.pricing_procedure.value = res.value;
  //         setPricingProcedure(res.array);
  //       } else {
  //         setPricingProcedure(res.array);
  //       }
  //     }.bind(this)
  //     )
  //       .catch(function (error) {
  //         setLoader(false)
  //         console.log(error);
  //       });

  //       authCustomerStatisticGroup(JSON.stringify(customer_statistics_group_data)).then(function (response) {
  //         var res = response.data;
         
  //         if (res.status == 'true' && res.code == '200') {
  //           setCustomerStatisticGroup(res.array);
  //           formValues.customer_statistic_group.value = res.value;
  //           formValues.customer_statistic_group.error = false;
            
  //         } else {
  //           setCustomerStatisticGroup(res.array);
  //         }
  //       }.bind(this)
  //       )
  //         .catch(function (error) {
  //           setLoader(false)
  //           console.log(error);
  //         });
  //   authDivision(JSON.stringify(division_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setDivision(res.array);
  //     } else {
  //       setDivision(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authGoodsTAX(JSON.stringify(goods_tax_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setGoodsTAX(res.array);
  //     } else {
  //       setGoodsTAX(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authTermsofPayment(JSON.stringify(terms_of_payment_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setTermsPayment(res.array);
  //     } else {
  //       setTermsPayment(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authCompanyCode(JSON.stringify(company_code_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setCompanyCode(res.array);
  //     } else {
  //       setCompanyCode(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authPartnerFunction(JSON.stringify(partner_function_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setPartnerFunction(res.array);
  //     } else {
  //       setPartnerFunction(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authSalesOffice(JSON.stringify(sales_office_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setSalesOffice(res.array);
  //     } else {
  //       setSalesOffice(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authShippingCondition(JSON.stringify(shipping_condition_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setShippingCon(res.array);
  //       formValues.shipping_condition.value = res.value;
  //       formValues.shipping_condition.error = false;
  //       setSelectShippingCondition(res.value);
  //     } else {
  //       setShippingCon(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });

  //   authIndustryCode(JSON.stringify(industry_code_data)).then(function (response) {
  //     var res = response.data;
  //     if (res.status == 'true' && res.code == '200') {
  //       setIndustryCode(res.array);
  //     } else {
  //       setIndustryCode(res.array);
  //     }
  //   }.bind(this)
  //   )
  //     .catch(function (error) {
  //       setLoader(false)
  //       console.log(error);

  //     });
  //   if (event.value == 'Z011' || event.value == 'Z015' ) 
  //     {
  //             document.getElementById('form_heading').innerHTML = 'Marketing-Customer Creation';
  //             formValues.franchise_type.value = '';
  //             formValues.sold_to_party.value = '';
  //             const sales_organization_data = {
  //               "action": 'sales_organization'
  //             };

  //             authSalesOrganization(JSON.stringify(sales_organization_data)).then(function (response) {
  //               var res = response.data;
              
  //               if (res.status == 'true' && res.code == '200') {
  //                 setSalesOrganization(res.array);
  //               } else {
  //                 setSalesOrganization(res.array);
  //               }
  //             }.bind(this)
  //             )
  //               .catch(function (error) {
  //                 setLoader(false)
  //                 console.log(error);

  //               });

  //               document.getElementById('name3').style.display = 'block';
  //               document.getElementById('name4').style.display = 'block';
  //               document.getElementById('comments').style.display = 'block';
  //               document.getElementById('lifnr').style.display = 'none';
  //               document.getElementById('indicator').style.display = 'block';
  //               document.getElementById('marketing_rows').style.display = 'block';
  //               document.getElementById('creditControl').style.display = 'block';
  //               document.getElementById('franchise').style.display = 'none';
  //               document.getElementById('soldToParty').style.display = 'none';

  //               if(event.value == 'Z011' && selectDistributionChannel=='36')
  //               {
  //                setMKCustomerExist(true);
  //               }else{
  //                 setMKCustomerExist(false);
  //               }
     
  //   }else if(event.value == 'Z012'){
  //       document.getElementById('form_heading').innerHTML = 'Ship-To-Party-Customer Creation';
  //       formValues.credit_control_area.value = 'NA';
  //       formValues.credit_control_area.error = false;
  //       formValues.gstn.value = 'NA';
  //       formValues.gstn.error = false;
  //       formValues.franchise_type.value = '';
      
  //         const sales_organization_data = {
  //           "action": 'sales_organization'
  //         };
  //         authSalesOrganization(JSON.stringify(sales_organization_data)).then(function (response) {
  //           var res = response.data;
          
  //           if (res.status == 'true' && res.code == '200') {
  //             setSalesOrganization(res.array);
  //           } else {
  //             setSalesOrganization(res.array);
  //           }
  //         }.bind(this)
  //         )
  //           .catch(function (error) {
  //             setLoader(false)
  //             console.log(error);
  //           });
       
  //           document.getElementById('name3').style.display = 'block';
  //           document.getElementById('name4').style.display = 'block';
  //           document.getElementById('comments').style.display = 'block';
  //           document.getElementById('lifnr').style.display = 'none';
  //           document.getElementById('indicator').style.display = 'block';
  //           document.getElementById('marketing_rows').style.display = 'block';
  //           document.getElementById('creditControl').style.display = 'none';
  //           document.getElementById('franchise').style.display = 'none';
  //           document.getElementById('soldToParty').style.display = 'block';
  //           setMKCustomerExist(false);
  //   } else {
  //     document.getElementById('form_heading').innerHTML = 'Service-Customer Creation';
  //     const sales_organization_data = {
  //       "action": 'sales_organization'
  //     };

  //     authSalesOrganization(JSON.stringify(sales_organization_data)).then(function (response) {
  //       var res = response.data;
  //       if (res.status == 'true' && res.code == '200') {
  //         setSalesOrganization(res.array);
  //       } else {
  //         setSalesOrganization(res.array);
  //       }
  //     }.bind(this)
  //     )
  //       .catch(function (error) {
  //         setLoader(false)
  //         console.log(error);
  //       });
  //     document.getElementById('indicator').style.display = 'none';
  //     //formValues.name3.value = 'no need';
  //     formValues.indicator.value = 'X';
  //     setEP('0');
  //     formValues.business_partner.value = 'NA';
  //     formValues.sold_to_party.value = '';
  //     formValues.customer_group.value = '';
  //     //formValues.partner_function.value= 'IP';
  //     setPartnerFunc('IP');
  //     formValues.name3.value = 'NA';
  //     document.getElementById('name3').style.display = 'none';
  //     document.getElementById('name4').style.display = 'none';
  //     document.getElementById('comments').style.display = 'none';
  //     document.getElementById('lifnr').style.display = 'block';
  //     document.getElementById('marketing_rows').style.display = 'none';
  //     document.getElementById('creditControl').style.display = 'block';
  //     document.getElementById('franchise').style.display = 'block';
  //     document.getElementById('soldToParty').style.display = 'none';
  //     setMKCustomerExist(false);
  //   }

  //   if (event.value == 'Z011' || event.value == 'Z015' || event.value == 'Z031' )
  //   {
  //     setShowTANNumber(true);
  //   }else{

  //     setShowTANNumber(false);
  //     formValues.tan.value = '';
  //   }


  // }
  const selectGSTNFile = async(event) => {
    setLoaderSpinner(true);
    //console.log(event.target.files);
    setSelectedFiles(event.target.files);
    try{
      for (let i = 0; i < event.target.files.length; i++) {
      var response =await  fileBPUpload(event.target.files[i])
              var res = response.data;
              if (res == 'no file found') {
                setLoaderSpinner(false);
                if (!toast.isActive(toastId.current)) {
                  toastId.current = toast.warning("GST file size exceeds 2 MB, all files may not be uplaoded successfully!");
                }

              } else {
                if (res.code == "200" && res.status == "true") {
                  let filepath = res.filepath;
                  const data = {
                    "action": 'gstn_ocr',
                    "filepath": filepath
                  };
                  //console.log(data);
                  authBP(JSON.stringify(data)).then(function (response) {
                    var res = response.data;
                    
                    if (res.status == 'true') {
                      setLoaderSpinner(false);
                      let gstin = res.gstn;
                      let pan = res.pan;
                      let legal_name = res.legal_name;
                      let address = res.address;
                      let postal_code = res.postal_code;

                      formValues.gstn.value = gstin;
                      formValues.pan.value = pan;
                      formValues.title.value = legal_name;
                      formValues.street.value = address;
                      formValues.postal_code.value = postal_code;

                      formValues.gstn.error = false;
                      formValues.pan.error = false;
                      formValues.title.error = false;
                      formValues.street.error = false;
                      formValues.postal_code.error = false;

                      document.getElementById('gstn').value = gstin;
                      document.getElementById('pan').value = pan;
                      document.getElementById('title').value = legal_name;
                      document.getElementById('street').value = address;
                      document.getElementById('postal_code').value = postal_code;
                    } else {
                      setLoaderSpinner(false);
                      if (!toast.isActive(toastId.current)) {
                        toastId.current = toast.warning("Failed to fetch!");
                      }
                    }
                  }.bind(this)
                  )
                    .catch(function (error) {
                      console.log(error);
                    });
                  
                  // document_arr.push({
                  //   filename: res.filename,
                  //   filepath: res.filepath,
                  // });
                  
                  
                } else {
                }
              }



      }
    }catch(error){
      console.log(error)
    }





  };
  const selectPANFile = (event) => {
   
    setSelectedPANFiles(event.target.files);
  };
  // const handleChangeCity = async (event) => {
  //   formValues.city.error = false;
  //   setSelectcity1(event.value);
  // }
  const handleChangeDistrict = async (event) => {
    formValues.district.error = false;
    setSelectDistrict(event.value);
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues }

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;

      if (currentValue === '') {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true
          }
        }
      }

    }
    setFormValues(newFormValues);
    console.log(formValues);
    //Save customer code
    if (
        (formValues.client.value == '' || formValues.client.value == undefined)
        || (formValues.supplier.value == '' || formValues.supplier.value == undefined) 
        || (formValues.title.value == '' || formValues.title.value == undefined) 
        || (formValues.postal_code.value == '' || formValues.postal_code.value == undefined) 
        || (formValues.city.value == '' || formValues.city.value == undefined) 
        || (formValues.region.value == '' || formValues.region.value == undefined) 
        || (formValues.street.value == '' || formValues.street.value == undefined) 
        || (formValues.email.value == '' || formValues.email.value == undefined) 
        || (formValues.pan.value == '' || formValues.pan.value == undefined) 
        || (formValues.gstn.value == '' || formValues.gstn.value == undefined) 
        || (formValues.country.value == '' || formValues.country.value == undefined) 
        || (formValues.telephone_number.value == '' || formValues.telephone_number.value == undefined) 
        || (formValues.company_code.value == '' || formValues.company_code.value == undefined) 
        || (formValues.reconciliation_account.value == '' || formValues.reconciliation_account.value == undefined) 
        || (formValues.payment_terms.value == '' || formValues.payment_terms.value == undefined) 
        ) {
          
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.warning("Mandatory field(s) missing", {
              className: "small-toast",
            });
          }
        } else {
        
          let gstn = formValues.gstn.value;
          let pan = formValues.pan.value;
          let mobile = formValues.telephone_number.value;
          let gstn_length = gstn.length;
          let pan_length = pan.length;
          let mobile_length = mobile.length;

          if(mobile_length==10)
            {
              if (gstn != 'NA' && pan != 'NA') {
                if (gstn_length == 15 && pan_length == 10) {
      
                
                      //var pan_fourth_char = pan.charAt(3);
                  
        
                        var strFirstTwo = gstn.substring(0, 2);
                        let isnum = /^\d+$/.test(strFirstTwo);
                    
                          if (isnum) {
                            var ret = gstn.replace(strFirstTwo, '');
                            var panVlaue = ret.slice(0, -3);
                            let panNo = document.getElementById("pan").value;
                            
                            if (panVlaue == panNo) {
                              let fourteen_char = gstn.charAt(13);
                              let fourteen_char_isnum = /^\d+$/.test(fourteen_char);
                              if (fourteen_char_isnum) {
                                if (!toast.isActive(toastId.current)) {
                                  toastId.current = toast.warning('14th character can not be numeric in GSTN!');
                                }
                              } else {
                                  let document_arr = [];
                                  let gstn_document_arr = [];
                                  //let other_document_arr = [];
                                  setLoader(true);
                                  if (selectedPANFiles.length > 0 && selectedFiles.length > 0) {
                                    try{
                                    for (let i = 0; i < selectedPANFiles.length; i++) {
                
                                    var response =await  fileBPUpload(selectedPANFiles[i])
                                      
                                            var res = response.data;
                                            
                                            if (res == 'no file found') {
                
                                              if (!toast.isActive(toastId.current)) {
                                                toastId.current = toast.warning("PAN file size exceeds 2 MB, all files may not be uplaoded successfully!");
                                              }
                
                                            } else {
                                              if (res.code == "200" && res.status == "true") {
                                                
                                                document_arr.push({
                                                  filename: res.filename,
                                                  filepath: res.filepath,
                                                });
                                                
                                              } else {
                                              }
                                            }
                                    }
                                  }catch(error){
                                    console.log(error)
                                  }
                                  try{
                                    for (let k = 0; k < selectedFiles.length; k++) {
                        
                                    var response2 =await fileBPUpload(selectedFiles[k])
                                      
                                            var res2 = response2.data;
                                            
                                            if (res2 == 'no file found') {
                        
                                              if (!toast.isActive(toastId.current)) {
                                                toastId.current = toast.warning("GSTN File size exceeds 2 MB, all files may not be uplaoded successfully!");
                                              }
                        
                                            } else {
                                              if (res2.code == "200" && res2.status == "true") {
                                                gstn_document_arr.push({
                                                  filename: res2.filename,
                                                  filepath: res2.filepath,
                                                });
                                                
                                                
                                              } else {
                                              }
                                            }
                                    }
                                  }catch(error){
                                    console.log(error)
                                  }
                                  //Other document upload code
                                  // try{
                                  //   for (let j = 0; j < acceptedFiles.length; j++) {
                        
                                  //   var response3 =await fileUpload(acceptedFiles[j])
                                      
                                  //           var res3 = response3.data;
                                            
                                  //           if (res3 == 'no file found') {
                        
                                  //             if (!toast.isActive(toastId.current)) {
                                  //               toastId.current = toast.warning("Other file size exceeds 2 MB, all files may not be uplaoded successfully!");
                                  //             }
                        
                                  //           } else {
                                  //             if (res3.code == "200" && res3.status == "true") {
                                                
                                  //               other_document_arr.push({
                                  //                 filename: res3.filename,
                                  //                 filepath: res3.filepath,
                                  //               });
                                                
                                                
                                  //             } else {
                                  //             }
                                  //           }
                        
                        
                        
                                  //   }
                                  // }catch(error){
                                  //   console.log(error)
                                  // }
                                  setLoader(false);
                                    setLoader(true);
                                    
                                                const data = {
                                                  "action": 'save_customer',
                                                  "initiator_id": userID,
                                                  "initiator_email": userEmail,
                                                  "initiator_name": userName,
                                                  "client": formValues.client.value,
                                                  "supplier": formValues.supplier.value,
                                                  "title": formValues.title.value,
                                                  "postal_code": formValues.postal_code.value,
                                                  "city": formValues.city.value,
                                                  "street": formValues.street.value,
                                                  "region": formValues.region.value,
                                                  "country": formValues.country.value,
                                                  "language_key": formValues.language_key.value,
                                                  "telephone_number": formValues.telephone_number.value,
                                                  "email": formValues.email.value,
                                                  "pan": formValues.pan.value,
                                                  "gstn": formValues.gstn.value,
                                                  "account_group": formValues.account_group.value,
                                                  "purchase_organization": formValues.purchase_organization.value,
                                                  "currency": formValues.currency.value,
                                                  "gr_based": formValues.gr_based.value,
                                                  "incoterms1": formValues.incoterms1.value,
                                                  "incoterms2": formValues.incoterms2.value,
                                                  "schema_group_supplier": formValues.schema_group_supplier.value,
                                                  "purchasing_group": formValues.purchasing_group.value,
                                                  "incoterms_location1": formValues.incoterms_location1.value,
                                                  "company_code": formValues.company_code.value,
                                                  "sort_key": formValues.sort_key.value,
                                                  "reconciliation_account": formValues.reconciliation_account.value,
                                                  "payment_terms": formValues.payment_terms.value,
                                                  "check_double_invoice": formValues.check_double_invoice.value,
                                                  "previous_account_no": formValues.previous_account_no.value,
                                                  "wtax_country": formValues.wtax_country.value,
                                                  "pan_file_details": JSON.stringify(document_arr),
                                                  "gstn_file_details": JSON.stringify(gstn_document_arr)
                                                };
                                                console.log(JSON.stringify(data));
                                                authBPCreation(JSON.stringify(data)).then(function (response) {
                                                  var res = response.data;
                                                  //console.log(res);
                                                  if (res.status == 'true' && res.code == '200') {
                                                            setLoader(false);
                                                            MySwal.fire({
                                                              title: <strong>Success</strong>,
                                                              html: <i><p>Business Partner Created successfully!</p><p>Request ID : {res.document_number}</p></i>,
                                                              icon: 'success',
                        
                                                            }
                                                          ).then(() => {
                                                            navigate("/bp-list");
                                                          })
                                                  } else {
                                                    setLoader(false);
                                                    if (!toast.isActive(toastId.current)) {
                                                      toastId.current = toast.warning(res.message);
                                                    }
                                                  }
                                                }.bind(this)
                                                )
                                                  .catch(function (error) {
                                                    setLoader(false)
                                                    console.log(error);
                                                  });
                                  } else {
                                    if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("please uplaod PAN and GSTN Document");
                                    }
                                  }
                
                              }
                
                            } else {
                
                              if (!toast.isActive(toastId.current)) {
                                toastId.current = toast.warning('3rd to 10th character of GSTN are not matching with customer PAN!');
                              }
                            }
                
                          } else {
                            if (!toast.isActive(toastId.current)) {
                              toastId.current = toast.warning('State code must be numeric!');
                            }
                          }
                } else {
                  if (!toast.isActive(toastId.current)) {
                    toastId.current = toast.warning("GSTN or PAN character lenght are not appropriate!");
                  }
                }
              } else {
               
              }
            }else{
              if (!toast.isActive(toastId.current)) {
                toastId.current = toast.warning("Mobile number should be exacly 10 digit");
              }
            }
        }

  }
  const handleChangeClient = async (event) => {
    formValues.client.value = event.value;
  }
  const handleChangeSupplier = async (event) => {
    formValues.supplier.value = event.value;
  }
  const handleChangeAccountGroup = async (event) => {
    formValues.account_group.value = event.value;
  }
  const handleChangePurchaseOrganization = async (event) => {
    formValues.purchase_organization.value = event.value;
  }
  const handleChangeIncoterms1 = async (event) => {
    formValues.incoterms1.value = event.value;
  }
  const handleChangeIncoterms2 = async (event) => {
    formValues.incoterms2.value = event.value;
  }
  const handleChangeSchemaGroupSupplier = async (event) => {
    formValues.schema_group_supplier.value = event.value;
  }
  const handleChangePurchaseGroup = async (event) => {
    formValues.purchasing_group.value = event.value;
  }
  const handleChangeIncotermLocation1 = async (event) => {
    formValues.purchasing_group.value = event.value;
  }
  const handleChangeCompanyCode = async (event) => {
    formValues.company_code.value = event.value;
  }
  const handleChangeReconciliationAccount = async (event) => {
    formValues.reconciliation_account.value = event.value;
  }
  const handleChangePaymentTerms = async (event) => {
    formValues.payment_terms.value = event.value;
  }
  const handleChangeTitle = async (event) => {
    formValues.title.value = event.target.value;
  }
  const handleChangePostalCode = async (event) => {
    formValues.postal_code.value = event.target.value;
  }
  const handleChangeCity = async (event) => {
    formValues.city.value = event.target.value;
  }
  const handleChangeStreet = async (event) => {
    formValues.street.value = event.target.value;
  }
  const handleChangeRegion = async (event) => {
    formValues.region.value = event.target.value;
  }
  const handleChangeCountry = async (event) => {
    formValues.country.value = event.target.value;
  }
  const handleChangeWtaxCountry = async (event) => {
    formValues.wtax_country.value = event.target.value;
  }
  const handleChangeLanguage = async (event) => {
    formValues.language_key.value = event.target.value;
  }
  const handleChangePAN = async (event) => {
    formValues.pan.value = event.target.value;
  }
  const handleChangeCurrency = async (event) => {
    formValues.currency.value = event.target.value;
  }
  const handleChangeGRBased = async (event) => {
    formValues.gr_based.value = event.target.value;
  }
  const handleChangeSortKey = async (event) => {
    formValues.sort_key.value = event.target.value;
  }
  const handleChangeDoubleInvoice = async (event) => {
    formValues.check_double_invoice.value = event.target.value;
  }
  const handleChangePreAccountNo = async (event) => {
    formValues.previous_account_no.value = event.target.value;
  }

 const handleChangeVariant = async (event) => {
  let variant = event.value;
  if(variant=='bp')
  {
    setBPAccess(true);
    setCustomerAccess(false);
    setVendorAccess(false);
  }else if(variant=='customer')
  {
    setBPAccess(false);
    setCustomerAccess(true);
    setVendorAccess(false);

  }else if(variant=='vendor')
  {
    setBPAccess(false);
    setCustomerAccess(false);
    setVendorAccess(true);

  }else{
    setBPAccess(false);
    setCustomerAccess(false);
    setVendorAccess(false);
  }
}
  return (
    <>
      {/* <DashboardNavbar /> */}
      <ToastContainer />
        <Grid>
         

          <SoftBox py={3} className="customerblock">
          <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
          <Card sx={{ overflow: "visible" }}>
          <SoftBox p={3}>
          <SoftTypography variant="h5" id="form_heading">Variant</SoftTypography>

          <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12}>
                            <SoftBox mb={12}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Choose Variant
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="variant"
                                id="variant"
                                onChange={handleChangeVariant}
                                options={[
                                  { value: "customer", label: "Customer Creation" },
                                  { value: "bp", label: "Business Partner Creation" },
                                  { value: "vendor", label: "Vendor Creation" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                         
                         

                        </Grid>
                      </SoftBox>


          </SoftBox>
          <Grid>
                        {loaderspinner ? <div style={{
                          position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                          zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                        }}>
                          <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                        </div> : ""}
          </Grid>
          </Card> 
          </Grid>
          </Grid>
          </SoftBox>
           {bpAccess ? 
           <SoftBox className="bp">
             <form noValidate onSubmit={handleSubmit}>
            <SoftBox py={3} className="customerblock">
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <Card sx={{ overflow: "visible" }}>
                    <SoftBox p={3}>
                      <SoftTypography variant="h5" id="form_heading">General Data</SoftTypography>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  GSTN Document*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="file"
                                size="medium"
                                name="gstn_document"
                                id="gstn_document"
                                onChange={selectGSTNFile}
                                multiple
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="mkcustomer">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  PAN Document*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="file"
                                size="medium"
                                name="pan_document"
                                id="pan_document"
                                onChange={selectPANFile}
                                multiple
                              />
                          </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  GSTN *
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                name="gstn"
                                id="gstn"
                                defaultValue={formValues.gstn.value}
                                error={formValues.gstn.error}
                                onChange={handleChangeGSTN}
                                placeholder="GSTN"
                                size="medium"
                                inputProps={{ maxLength: "15" }}
                              />
                            </SoftBox>
                          </Grid>
                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Client*
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="client"
                                id="client"
                                error={formValues.client.error}
                                onChange={handleChangeClient}
                                options={[
                                  { value: "1000", label: "1000" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Supplier*
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="supplier"
                                id="supplier"
                                error={formValues.supplier.error}
                                onChange={handleChangeSupplier}
                                options={[
                                  { value: "YAVT003", label: "YAVT003" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Title*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                placeholder="Title"
                                name="title"
                                error={formValues.title.error}
                                id="title"
                                onChange={handleChangeTitle}
                                size="medium" />
                            </SoftBox>
                          </Grid>

                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                 Postal Code *
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                placeholder="Postal Code"
                                id="postal_code"
                                error={formValues.postal_code.error}
                                size="medium"
                                inputProps={{ maxLength: "6" }}
                                onChange={handleChangePostalCode} />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  City*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                error={formValues.city.error}
                                placeholder="City"
                                id="city"
                                onChange={handleChangeCity}
                                size="medium" />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Street *
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                error={formValues.street.error}
                                placeholder="Street"
                                id="street"
                                onChange={handleChangeStreet}
                                multiline rows={5}
                                size="medium" />
                            </SoftBox>
                          </Grid>
                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Region*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                error={formValues.region.error}
                                placeholder="Region"
                                id="region"
                                onChange={handleChangeRegion}
                                size="medium" />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="mkcustomer">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Country*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                id="country"
                                error={formValues.country.error}
                                defaultValue={formValues.country.value}
                                placeholder="Country"
                                onChange={handleChangeCountry}
                                size="medium"
                                 />
                          </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="mkcustomer">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Language Key
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                id="language"
                                error={formValues.language_key.error}
                                defaultValue={formValues.language_key.value}
                                onChange={handleChangeLanguage}
                                placeholder="Language Key"
                                size="medium"
                                 />
                          </SoftBox>
                          </Grid>
                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Telephone Number 1*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                id="telephone"
                                name="telephone"
                                placeholder="Telephone"
                                error={formValues.telephone_number.error}
                                size="medium"
                                onChange={handleChangeTelephone}
                                inputProps={{ maxLength: "10" }} />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="mkcustomer">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Email Address*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                name="email"
                                onChange={handleChangeEmail}
                                error={formValues.email.error}
                                type="email"
                                placeholder="Email"
                                inputProps={{ maxLength: "241" }}
                              />
                          </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="mkcustomer">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  PAN(Permanent account number)*
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                id="pan"
                                onChange={handleChangePAN}
                                error={formValues.pan.error}
                                name="pan"
                                placeholder="Permanent account number"
                                size="medium"
                                 />
                          </SoftBox>
                          </Grid>
                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="mkcustomer">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Account Group*
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="account_group"
                                id="account_group"
                                error={formValues.account_group.error}
                                onChange={handleChangeAccountGroup}
                                options={[
                                  { value: "ZYRN", label: "ZYRN" }
                                ]}
                              />
                          </SoftBox>
                          </Grid>
                        <Grid item xs={12} sm={4}>
                            
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          
                          </Grid>
                          
                        </Grid>
                      </SoftBox>

                      

                    </SoftBox>
                  </Card>
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox py={3} className="customerblock">
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <Card sx={{ overflow: "visible" }}>
                    <SoftBox p={3}>
                      <SoftTypography variant="h5" id="form_heading">Purchase Data</SoftTypography>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Purchase Organization
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="purchase_organization"
                                id="purchase_organization"
                                onChange={handleChangePurchaseOrganization}
                                options={[
                                  { value: "P002", label: "P002" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Order currency
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                placeholder="Order currency"
                                id="currency"
                                size="medium"
                                onChange={handleChangeCurrency}
                                inputProps={{ maxLength: "5" }} />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3} id="name3">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                 GR-Based Inv. Verif.
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                placeholder="GR-Based Inv. Verif."
                                id="gr_based"
                                onChange={handleChangeGRBased}
                                name="gr_based"
                                size="medium"
                              />
                            </SoftBox>
                          </Grid>
                         
                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Incoterms
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="incoterms"
                                id="incoterms"
                                onChange={handleChangeIncoterms1}
                                options={[
                                  { value: "CFR", label: "CFR" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                 Incoterms (Part 2)
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="incoterms2"
                                id="incoterms2"
                                onChange={handleChangeIncoterms2}
                                options={[
                                  { value: "ERODE", label: "ERODE" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3} id="name3">
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                 Schema Group Supplier
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="schema_group_supplier"
                                id="schema_group_supplier"
                                onChange={handleChangeSchemaGroupSupplier}
                                options={[
                                  { value: "YR", label: "YR" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                         
                        </Grid>
                      </SoftBox>

                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Purchasing Group
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="purchasing_group"
                                id="purchasing_group"
                                onChange={handleChangePurchaseGroup}
                                options={[
                                  { value: "K01", label: "K01" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                 Incoterms Location 1
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="incoterm_location1"
                                id="incoterm_location1"
                                onChange={handleChangeIncotermLocation1}
                                options={[
                                  { value: "ERODE", label: "ERODE" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            
                          </Grid>
                         
                        </Grid>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox py={3} className="customerblock">
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <Card sx={{ overflow: "visible" }}>
                    <SoftBox p={3}>
                      <SoftTypography variant="h5" id="form_heading">Company Data</SoftTypography>
                      <SoftBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Company Code*
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="company_code"
                                id="company_code"
                                error={formValues.company_code.error}
                                onChange={handleChangeCompanyCode}
                                options={[
                                  { value: "R001", label: "R001" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>

                         
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Sort key
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                placeholder="Sort key"
                                id="sort_key"
                                onChange={handleChangeSortKey}
                                size="medium" />
                            </SoftBox>
                          </Grid>
                          
                         
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Reconciliation Account*
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="reconciliation_account"
                                id="reconciliation_account"
                                error={formValues.reconciliation_account.error}
                                onChange={handleChangeReconciliationAccount}
                                options={[
                                  { value: "260000", label: "260000" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                        
                        </Grid>
                      </SoftBox>
                      <SoftBox mt={1}>
                        <Grid container spacing={4}>
                      
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Terms of Payment*
                                </SoftTypography>
                              </SoftBox>
                              <SoftSelect
                                name="payment_terms"
                                id="payment_terms"
                                error={formValues.payment_terms.error}
                                onChange={handleChangePaymentTerms}
                                options={[
                                  { value: "ZRY2", label: "ZRY2" }
                                ]}
                              />
                            </SoftBox>
                          </Grid>
                         

                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Check Double Invoice
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput
                                type="text"
                                id='double_invoice'
                                placeholder="Check Double Invoice"
                                onChange={handleChangeDoubleInvoice}
                                />
                            </SoftBox>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  Previous Account No.
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput 
                              type="text" 
                              id='previous_account_no' 
                              name="previous_account_no"
                              onChange={handleChangePreAccountNo}
                              placeholder="Previous Account No."  />
                            </SoftBox>
                          </Grid>
                         
                        </Grid>
                      </SoftBox>
                      <SoftBox mt={1}>
                        <Grid container spacing={4}>
                      
                          <Grid item xs={12} sm={4}>
                            <SoftBox mb={3}>
                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography
                                  component="label"
                                  variant="caption"
                                  fontWeight="bold"
                                  textTransform="capitalize"
                                >
                                  WTax Country
                                </SoftTypography>
                              </SoftBox>
                              <SoftInput 
                              type="text" 
                              id='wtax_country' 
                              name="wtax_country"
                              onChange={handleChangeWtaxCountry}
                              placeholder="WTax Country"  />
                            </SoftBox>
                          </Grid>
                        
                          <Grid item xs={12} sm={4}>
                           
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            
                          </Grid>
                         
                        </Grid>
                      </SoftBox>
                     

                    </SoftBox>
                  </Card>
                </Grid>
              </Grid>
            </SoftBox>
            <Grid container spacing={3} className="customerblock">
              <Grid item xs={12} lg={12}>
                <Card sx={{ overflow: "visible" }}>
                  <SoftBox p={3}>
                    <SoftBox mt={1}>
                      <Grid item xs={12} lg={12}>
                        <SoftBox display="flex" justifyContent="flex-end">
                          <Bars
                            height="40"
                            width="40"
                            color="#4fa94d"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={loader}
                          />
                        </SoftBox>

                        <SoftBox display="flex" justifyContent="flex-end">
                          <SoftButton variant="gradient" color="info" type="submit">
                            save
                          </SoftButton>
                        </SoftBox>

                      </Grid>
                      <Grid>
                        {loaderspinner ? <div style={{
                          position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                          zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                        }}>
                          <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                        </div> : ""}
                      </Grid>
                    </SoftBox>
                  </SoftBox>
                </Card>
              </Grid>
            </Grid>
            </form>
            </SoftBox>
            : null }
            {customerAccess ?
            <SoftBox className="customer">
            <Customer />
            </SoftBox>
             : null }

             {vendorAccess ? 
            <SoftBox className="vendor">
             <Vendor />
            </SoftBox>
            : null }
        </Grid>
       
      <Footer />
    </>
  );
}

export default Bp;
